import React from 'react';
import { useQuery } from '@common/hooks';
import { Banner, TimeWithTimeZone } from '@common/components';
import { SUBMITTAL_PACKET_LAST_UPDATED_INFO_QUERY } from '@applicant-flow/graphql';

export function SubmittalPacketLastUpdatedInfo({
  applicationId,
}: {
  applicationId: string;
}) {
  const { data, loading, error } = useQuery(
    SUBMITTAL_PACKET_LAST_UPDATED_INFO_QUERY,
    {
      variables: { id: applicationId },
    }
  );
  const response = data?.staffingRequestApplication?.lastOfferChangeResponse;

  const responseCreatedAt = response?.createdAt || '';
  const requestCreatedAt = response?.offerChangeRequest.createdAt || '';

  if (loading || error || !responseCreatedAt || !requestCreatedAt) {
    return null;
  }

  const formatDate = (date: string) => (
    <TimeWithTimeZone date={date} variant="long_format" />
  );

  return (
    <Banner type="info">
      The Supplier updated this packet on {formatDate(responseCreatedAt)} based
      on a Change Request on {formatDate(requestCreatedAt)}.
    </Banner>
  );
}
